import React from "react";
import AppFooter from "../../components/AppFooter/AppFooter";
import AppServices from "../../components/AppServices/AppServices";

export default function Services() {
  return (
    <div>
      <AppServices />
      <AppFooter />
    </div>
  );
}
